<template>
	<div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s4">
						
						<select id='edital' v-model="editalSelected" v-on:change="verifyEdital()">
							<option value=0>Todos os editais</option>
							<option v-for="edital in this.listaEditais" :value="edital.id" >Edital {{edital.numero}}/{{edital.ano}}</option>
						</select>
						
					</div>
				</div>
			</div>
		</div>

    <div class="row">
      <div class="col s12 m12 l12 xl12">

        <table>

          <thead>
            <tr>
              <th class="hide-on-med-and-down">
                #
              </th>
              <th>
                Ação
                <a class="left" href="#" @click="toggleOrder($event, 'projeto.titulo')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
                </a>
              </th>
              <th v-if="perfil != 'proponente'">
                Proponente
                <a class="left" href="#" @click="toggleOrder($event, 'projeto.curriculo.usuario.name')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProponente }" >sort</i>
                </a>
              </th>
              <th v-if="perfil != 'discente'" class="hide-on-med-and-down">
                Bolsista
                <a class="left" href="#" @click="toggleOrder($event, 'aluno.name')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyBolsista }" >sort</i>
                </a>
              </th>
			  <th>
                Período
              </th>
              <th v-if="perfil">
                Editar
              </th>
			  <th v-else>
                Alertas
              </th>
			  <th>
                Detalhes
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(relatorio, index) in filteredRelatorios">
				<template v-if="relatorio.aluno">
				  <td class="hide-on-med-and-down">{{ index + 1 }}</td>
				  <td>
					<a :href="'/projetos/'+relatorio.projeto.id+'/edit/editable/false'">{{ relatorio.projeto.titulo }}</a>
				  </td>
				  <td v-if="perfil != 'proponente'">
					<a :href="'/usuario/' + relatorio.projeto.curriculo.usuario.id">{{ relatorio.projeto.curriculo.usuario.name }}</a>
				  </td>
				  <td v-if="perfil != 'discente'" class="hide-on-med-and-down">
					<a :href="'/usuario/' + relatorio.aluno.id">{{ relatorio.aluno.name }}</a>
				  </td>
				  <td>{{ formatarData(relatorio.entrada) }}-<br>{{ relatorio.saida? formatarData(relatorio.saida) : '' }}</td>	
				  <td v-if="perfil">
					<a v-if="podeAvaliar(relatorio) && !alunoSaiuAntes(relatorio)" :href="'/bolsas/relatorios/true/' + relatorio.id" class="waves-effect waves-light btn-small" title="Editar">
					  <i class="material-icons">edit</i>
					</a>
					<label v-if="alunoSaiuAntes(relatorio)" class="grey waves-effect waves-light btn-small left" title="Aluno saiu antes do prazo mínimo.">
					  <i class="material-icons">block</i>
					</label>
					<label v-if="!alunoSaiuAntes(relatorio) && !podeAvaliar(relatorio)" class="cyan waves-effect waves-light btn-small left" title="Aluno ainda não cumpriu o prazo mínimo.">
					  <i class="material-icons">warning</i>
					</label>
				  </td>
				  <td v-if="!perfil">
					<label v-if="alunoSaiuAntes(relatorio)" class="grey waves-effect waves-light btn-small left" title="Aluno saiu antes do prazo mínimo.">
					  <i class="material-icons">block</i>
					</label>
				  </td>
				  <td>
					<a v-if="!alunoSaiuAntes(relatorio) && podeAvaliar(relatorio)" :href="'/bolsas/relatorios/false/' + relatorio.id" class="waves-effect waves-light btn-small" title="Ver">
					  <i class="material-icons">book</i>
					</a>
				  </td>
				</template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
      name: "VueRelatoriosBolsasList",
      props: [
        'editais',
		'perfil'
      ],
	  components: {
         Loading
	  },
      data () {
        return {
		  listaEditais: JSON.parse(this.editais),
		  editalSelected: JSON.parse(this.editais).length? JSON.parse(this.editais)[0].id : null,
          relatorios: [],
          sortProperty: 'id',
          sortDirection: 'desc',
          filterTerm: '',
          sortPropertyId: true,
          sortPropertyProjeto: false,
          sortPropertyProponente: false,
          sortPropertyBolsista: false,
        }
      },
      computed: {
        listOp: function () {
          this.relatorios = _.orderBy(this.relatorios, this.sortProperty, this.sortDirection)
        },
        filteredRelatorios: function () {
          var self = this
          return _.orderBy(self.relatorios.filter(function (relatorio) {
            var searchRegex = new RegExp(self.filterTerm, 'i')
            return (
              searchRegex.test(relatorio.projeto.titulo) ||
              searchRegex.test(relatorio.projeto.curriculo.usuario.name) ||
              (relatorio.aluno && searchRegex.test(relatorio.aluno.name))
            )
          }), this.sortProperty, this.sortDirection)
        },
      },
      methods: {
        toggleOrder (ev, field) {
          ev.preventDefault()
          if (this.sortProperty == field){
            if (this.sortDirection == 'asc')
              this.sortDirection = 'desc'
            else
              this.sortDirection = 'asc'
          } else {
            this.iconsColor(this.sortProperty, false)
            this.iconsColor(field, true)
            this.sortProperty = field
            this.sortDirection = 'asc'
          }
        },
        iconsColor(field, value){
          switch (field) {
            case 'id':
              this.sortPropertyId = value
              break;
            case 'projeto.titulo':
              this.sortPropertyProjeto = value
              break;
            case 'projeto.curriculo.usuario.name':
              this.sortPropertyProponente = value
              break;
            case 'aluno.name':
              this.sortPropertyBolsista = value
              break;
            default:
          }
        },
		verifyEdital: function () {
			if (this.editalSelected) {
				let estilo = document.getElementById('spinner').style;
						
				estilo.display = null;
				this.$http.get('/api/bolsas/relatorios/' + this.editalSelected + '/' + this.perfil).then((req) => {this.relatorios = req.body; estilo.display = 'none';})
			}
		}, 
		formatarData(data) {
			var objeto = new Date(data);
			return objeto.getDate() + '/' + (objeto.getMonth() + 1) + '/' + objeto.getFullYear(); 
		},
		alunoSaiuAntes(relatorio) {
			if (relatorio.saida) {
				var inicio = new Date(relatorio.entrada);
				inicio.setDate(inicio.getDate() + relatorio.projeto.curriculo.edital.min_dias_bolsista);
				if (new Date(relatorio.saida) < inicio)
					return true;
			}
			return false;	
		},
		podeAvaliar(relatorio) {
			var inicio = new Date(relatorio.entrada);
			inicio.setDate(inicio.getDate() + relatorio.projeto.curriculo.edital.min_dias_bolsista);
			if (new Date() < inicio)
				return false;
			return true;
		}
		
	  },
	  mounted() {
			this.verifyEdital();
	  }
    }
</script>
